module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u=require('util/Util.js').default; var ls=require('ListService.js').default; 
    ; __append("\r\n    <div class=\"prop-header\"><span class=\"prop-label\">Accessibility</span></div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12 prop-separator-0 form-group-flex\">\r\n            <input type=\"checkbox\" name=\"reflowEnabled\" ")
    ; __append(escapeFn(u.isTrue(reflowEnabled) ? "checked" : "" ))
    ; __append("\r\n            ")
    ; __append(escapeFn( u.isTrue(enableReflow) ? "" : "disabled" ))
    ; __append(" class=\"form-radio-group\"/>\r\n                <label class=\"form-group-label\">Enable Reflow View</label>\r\n                <div class=\"inline-help pa-tooltip\">?\r\n                    <span class=\"tooltiptext\">Reflow View showcases the form in an adaptive, single-column layout across\r\n                        all devices.\r\n\r\n                        ")
    ;  if(u.isTrue(enableReflow)){ 
    ; __append("\r\n                            ")
    ;  if(ls.timesWizardCompleted===0){ 
    ; __append("\r\n                                <br /><br />Ensure the mobile design is finished before activating reflow.\r\n                                ")
    ;  } 
    ; __append("\r\n                                    ")
    ;  }else{ 
    ; __append("\r\n                                        <br /><br />A mobile design is required to activate this option. <br /><br />\r\n                                        Click on 'Mobile View' within the designer view toolbar to kickstart the\r\n                                        creation of a new design.\r\n                    </span>\r\n                    ")
    ;  }
    ; __append("\r\n                </div>\r\n        </div>\r\n\r\n    </div>\r\n   <div class=\"row\" style=\"margin-top: 8px;\">\r\n        <div class=\"col-md-5 nopadding-r\"> \r\n            <label class=\"prop-sublabel label-70\">Focus Color</label>\r\n        </div>\r\n        <div class=\"col-md-7 nopadding\"> \r\n                 <input id=\"focusColorPicker\" name=\"focusColor\" type=\"color\" value=\"")
    ; __append(escapeFn( focusColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n                <input id=\"focusColor\" name=\"focusColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( focusColor ))
    ; __append("\" />\r\n                <div class=\"inline-help pa-tooltip\">?\r\n                    <span class=\"tooltiptext\">Select the focus indicator color. A high-contrast inner ring is automatically added to meet accessibility standards.\r\n                    </span>                   \r\n                </div>           \r\n        </div>\r\n    </div>")
  }
  return __output;

}